import { render, staticRenderFns } from "./UnilateralLocations.vue?vue&type=template&id=2992b8c5&scoped=true"
import script from "./UnilateralLocations.vue?vue&type=script&lang=js"
export * from "./UnilateralLocations.vue?vue&type=script&lang=js"
import style0 from "./UnilateralLocations.vue?vue&type=style&index=0&id=2992b8c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992b8c5",
  null
  
)

export default component.exports